<template>
  <div class="md-layout md-gutter md-alignment-center">
    <div class="md-layout-item md-size-100">

        <!-- 🛫 Tarjeta: Datos del Vuelo -->
        <md-card class="md-elevation-2 card-section">

          <md-card-content>
            <div class="form-horizontal">
              <md-field class="field-item">
                <label>Número de Vuelo</label>
                <md-input v-model="vuelo.numero_vuelo" />
              </md-field>

              <md-field class="field-item">
                <label>Fecha</label>
                <md-input type="date" v-model="vuelo.fecha" />
              </md-field>

              <md-field class="field-item">
                <label>Número de Constancia</label>
                <md-input v-model="vuelo.numero_constancia" />
              </md-field>

              <md-field class="field-item">
                <label>Regional</label>
                <md-select v-model="vuelo.regional_id">
                  <md-option v-for="regional in regionales" :key="regional.id" :value="regional.id">
                    {{ regional.nombre }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </md-card-content>
        </md-card>

        <!-- 🧾 Tarjeta: Servicios -->
        <md-card class="md-elevation-2 card-section">

          <md-card-content>
            <div v-for="(servicios, categoria) in serviciosPorCategoria" :key="categoria" class="categoria-group">
              <h3>{{ categoria }}</h3>

              <div v-for="servicio in servicios" :key="servicio.id" class="servicio-horizontal">
                <div class="servicio-nombre">
                  {{ servicio.nombre }} ({{ servicio.valor_unitario }} Bs)
                </div>

                <md-field class="field-small">
                  <label>Constancias</label>
                  <md-input type="number" min="0" v-model.number="servicio.constancias" />
                </md-field>

                <md-field class="field-medium">
                  <label>Observaciones</label>
                  <md-input v-model="servicio.observaciones" />
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>

        <!-- 📤 Botón y mensaje -->
        <div class="button-wrapper">
          <md-button class="md-raised md-primary" @click="registrarVuelo">
            Registrar vuelo y servicios
          </md-button>
        </div>

        <p v-if="mensaje" :class="{ error: error, success: !error }">
          {{ mensaje }}
        </p>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      vuelo: {
        numero_vuelo: '',
        fecha: '',
        numero_constancia: '',
        regional_id: null,
      },
      regionales: [],
      serviciosPorCategoria: {},
      mensaje: '',
      error: false,
    };
  },
  methods: {
    async obtenerRegionales() {
      const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php');
      this.regionales = await res.json();
    },
    async obtenerServicios() {
      const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/services/servicios_agrupados.php');
      const data = await res.json();
      this.serviciosPorCategoria = data;
    },
    async registrarVuelo() {
      const servicios = [];

      Object.values(this.serviciosPorCategoria).forEach(serviciosGrupo => {
        serviciosGrupo.forEach(servicio => {
          if (servicio.constancias > 0) {
            servicios.push({
              servicio_id: servicio.id,
              constancias: servicio.constancias,
              observaciones: servicio.observaciones || '',
            });
          }
        });
      });

      const payload = {
        vuelo: this.vuelo,
        servicios,
      };

      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/vuelo/registrar_vuelo_servicios.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const result = await res.json();
        this.mensaje = result.message;
        this.error = result.error;

        if (!result.error) {
          this.resetearFormulario();
        }
      } catch (err) {
        this.mensaje = 'Error de red.';
        this.error = true;
      }
    },
    resetearFormulario() {
      this.vuelo = {
        numero_vuelo: '',
        fecha: '',
        numero_constancia: '',
        regional_id: null,
      };
      Object.values(this.serviciosPorCategoria).forEach(serviciosGrupo => {
        serviciosGrupo.forEach(servicio => {
          servicio.constancias = 0;
          servicio.observaciones = '';
        });
      });
    },
  },
  mounted() {
    this.obtenerRegionales();
    this.obtenerServicios();
  },
};
</script>

<style scoped>
.form-container {
  padding: 20px;
  max-width: 1100px;
  margin: auto;
}

.form-horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.field-item {
  flex: 1 1 200px;
  min-width: 200px;
}

.categoria-group {
  margin-bottom: 30px;
  padding: 10px;
  border-left: 4px solid #0ad14c;
  background: #f9f9f9;
}

.servicio-horizontal {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.servicio-nombre {
  flex: 1 1 250px;
  font-weight: 500;
}

.field-small {
  flex: 0 0 120px;
}

.field-medium {
  flex: 1 1 300px;
}

.button-wrapper {
  margin-top: 20px;
}

.error {
  color: red;
}

.success {
  color: green;
}
</style>
